import axios from "axios";

const api = axios.create({
    baseURL: "https://inovartgold.com.br/ws/admin/",
    withCredentials: true,
});

export default api;
